import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '~~utils/CommonUtils';
import { TABLET_WIDTH } from '~~elements/Const';
import DefaultPlayerAvatarJPG from '~~elements/static/DefaultPlayerAvatar.jpg';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  .player-header {
    &--pic {
      width: 6rem;
      height: 6.72rem;
      // 3.5 : 4.5
      margin-right: 0.5rem;
      object-fit: cover;
    }
    &--name {
      font-size: 1.2rem;
    }
    &--change {
      color: #aaaaaa;
      display: flex;
      align-items: center;
      font-size: 0.8rem;

      select,
      option {
        color: #aaaaaa;
        &:hover,
        &:focus {
          display: inline-block;
        }
      }

      &-hint {
        font-size: 0.8rem;
        margin-left: 3rem;
      }
      select {
        display: none;
      }

      &:hover,
      &:focus {
        select {
          display: inline-block;
        }
      }
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    flex-direction: column;
    text-align: center;
    align-items: center;
    align-self: center;
    .player-header {
      &--change-hint {
        margin-left: 0;
      }
    }
  }
`;

const PlayerHeader = ({ players, playerIndex, setPlayerIndex }) => {
  const query = useQuery();
  useEffect(() => {
    const pindex = query.get('pindex');
    const queryplayerIndex = parseInt(pindex);
    if (!pindex || queryplayerIndex === playerIndex) {
      return;
    }

    if (Number.isNaN(queryplayerIndex) || queryplayerIndex < 0 || queryplayerIndex > players.length - 1) {
      return query.delete('pindex');
    }

    setPlayerIndex(queryplayerIndex);
  }, [query, setPlayerIndex, playerIndex, players]);

  const handleLeagueChange = (e) => {
    query.set({ pindex: e.target.value });
  };

  if (players.length === 0) {
    return <></>;
  }

  return (
    <StyledDiv>
      <img
        className="player-header--pic"
        src={players[playerIndex].info.avatar_url ? players[playerIndex].info.avatar_url : DefaultPlayerAvatarJPG}
        alt=""
      />
      <div>
        <div className="player-header--name">
          <a
            href={`${process.env.REACT_APP_MAINPAGE_URL}/player/${players[playerIndex].info.uniqid}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {players[playerIndex].info.name}
          </a>
        </div>
      </div>
      {players.length > 1 && (
        <label className="player-header--change" tabIndex="-1">
          <div className="player-header--change-hint">切換</div>
          <select value={playerIndex} onChange={handleLeagueChange}>
            {players.map((player, index) => (
              <option key={index} value={index}>
                {player.info.name}
              </option>
            ))}
          </select>
        </label>
      )}
    </StyledDiv>
  );
};

export default PlayerHeader;
